<div class="dialog">
    <div class="dialog-header">
        {{'shared.dialog.illustration.heading' | translate}}
    </div>

    <div class="dialog-body">
        <div [style.overflow]="'hidden'" id="picker-dialog-choices"></div>
    </div>
</div>
